import { Box } from '@mui/system';
import React from 'react';

const Footer = () => {
    return (
        <Box sx={{ flexGrow: 1, mt: '100px', mb: '0px', color: 'rgba(255, 255, 255, 0.689)', px: { xs: '10px', md: '0px' } }}>
            <h5>All Rights Reserved by Md. Akramul Hoque❤️ Copyright ©️{new Date().getFullYear()}</h5>
        </Box>
    );
};

export default Footer;